import { createTheme, responsiveFontSizes, Theme } from "@mui/material";

let darkTheme: Theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#ff782d",
      contrastText: "#fff",
    },
    secondary: {
      main: "#2A132E",
      contrastText: "#fff",
    },
    background: {
      default: "#121212",
      paper: "#1e1e1e",
    },
    success: {
      main: "#4caf50",
      light: "#2e7d32",
      dark: "#1b5e20",
      contrastText: "#fff",
    },
    error: {
      main: "#f44336",
      light: "#d32f2f",
      dark: "#c62828",
      contrastText: "#fff",
    },
    warning: {
      main: "#ff9800",
      light: "#f57c00",
      dark: "#ef6c00",
      contrastText: "#fff",
    },
    info: {
      main: "#2196f3",
      light: "#1976d2",
      dark: "#1565c0",
      contrastText: "#fff",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
      400: "#bdbdbd",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#2a2a2a",
    },
  },
});

darkTheme = responsiveFontSizes(darkTheme);

export default darkTheme;
